// import { TabProps } from './Tab'

import { CSSProperties } from 'react'

export enum SortTabEnums {
  TOTAL_WATCH = 'Total watch time',
  INTERACTION_TIME = 'Interaction time',
  ADD_REVENUE = 'Ad Revenue',
  TOTAL_SPENT = 'Total spent'
}

export type SortTabsProps = {
  style?: CSSProperties
}
